import { Component, Input, Output, OnChanges, EventEmitter, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR, AbstractControlDirective, AbstractControl } from '@angular/forms';
import { ValueAccessorBase } from '../value-accessor-base';
import { ActivatedRoute } from '@angular/router';
import { ILabel } from '../ILabel.model';
import moment from 'moment';
import { CurrentUser } from '../common/services/current-user.service';
import { TranslationService } from '../common/services/translation.service';
@Component({
    selector: 'cpq-date-picker',
    templateUrl: './cpq-date-picker.component.html',
    styleUrls: ['./cpq-date-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CpqDatePickerComponent,
            multi: true
        },
    ],
    standalone: false
})
export class CpqDatePickerComponent extends ValueAccessorBase<string> implements OnChanges {
  @Input('min') min: Date;
  @Input('max') max: Date;
  @Input('control') control: AbstractControlDirective | AbstractControl;
  @Input('name') name: string;
  @Input('label') label: ILabel;
  @Input('id') id: string;
  @Input('infoMessage') infoMessage?: ILabel;
  @Output('onInfoClick') onInfoClick = new EventEmitter<any>();
  @Output('onDatepickerClose') onDatepickerClose = new EventEmitter<any>();

  public tempDate: moment.Moment;
  public prevTempDate: moment.Moment;
  public placeholderMsg = '';

  constructor(
    public translationService: TranslationService,
    public route: ActivatedRoute,
    private userSettings: CurrentUser,
    private renderer: Renderer2
  ) {
    super();
    this.valueObserver.subscribe(() => {
      this.tempDate = moment(this.value, this.userSettings.dateFormats.display.dateInput);
      this.prevTempDate = this.tempDate;
    });
  }

  ngOnChanges() {
    if (this.label && this.label.placeholder) {
      this.placeholderMsg = this.translationService.translate(this.label.placeholder);
    }
  }

  dateChange(event: any) {
    if (event.targetElement.value === '') {
      this.value = null;
    } else {
      const temp = moment(event.targetElement.value, this.userSettings.dateFormats.display.dateInput, true);
      if (temp.isValid()) {
        this.value = temp.format(this.userSettings.dateFormats.display.dateInput);
      } else {
        this.tempDate = this.prevTempDate;
      }
    }
  }

  infoClicked() {
    this.onInfoClick.emit();
  }

  public onDatepickerOpen() {
    // timeout to allow for calendar opening animation
    setTimeout(() => {
      this.setTranslatedMonthName();

      const buttons = document.querySelectorAll('.mat-calendar-previous-button, .mat-calendar-next-button');
      if (buttons) {
        Array.from(buttons).forEach(button => {
          this.renderer.listen(button, "click", () => this.setTranslatedMonthName());
        })
      }
    }, 0);
  }

  public onDatepickerClosed() {
    this.onDatepickerClose.emit();
  }

  private setTranslatedMonthName() {
    const month = document.querySelector('.mat-calendar-body-cell').getAttribute('aria-label').split(' ')[0];
    const year = document.querySelector('.mat-calendar-body-cell').getAttribute('aria-label').split(' ')[2];
    let untranslatedMonth = document.querySelector('.mdc-button__label span');
    
    if(!year){
      return;
    }

    let translatedMonth;
    switch (month) {
      case 'January':
        translatedMonth = this.translationService.translate(`Msg.Month.January`);
        break;
      case 'February':
        translatedMonth = this.translationService.translate(`Msg.Month.February`);
        break;
      case 'March':
        translatedMonth = this.translationService.translate(`Msg.Month.March`);
        break;
      case 'April':
        translatedMonth = this.translationService.translate(`Msg.Month.April`);
        break;
      case 'May':
        translatedMonth = this.translationService.translate(`Msg.Month.May`);
        break;
      case 'June':
        translatedMonth = this.translationService.translate(`Msg.Month.June`);
        break;
      case 'July':
        translatedMonth = this.translationService.translate(`Msg.Month.July`);
        break;
      case 'August':
        translatedMonth = this.translationService.translate(`Msg.Month.August`);
        break;
      case 'September':
        translatedMonth = this.translationService.translate(`Msg.Month.September`);
        break;
      case 'October':
        translatedMonth = this.translationService.translate(`Msg.Month.October`);
        break;
      case 'November':
        translatedMonth = this.translationService.translate(`Msg.Month.November`);
        break;
      case 'December':
        translatedMonth = this.translationService.translate(`Msg.Month.December`);
        break;
      default:
        translatedMonth = `${month.toUpperCase()} ${year}`;
    };

    untranslatedMonth.textContent = `${translatedMonth.toUpperCase()} ${year}`;
  }
}
